import { formatDebtBalancesUserMessageForDisplay } from './debtBalanceSlidersMessages';
import { formatDraftedMessageUserMessageForDisplay } from './draftedMessageMessages';
import { formatMultiSelectUserMessageForDisplay } from './multiSelectMessages';
import { formatSliderUserMessageForDisplay } from './sliderMessages';

/** Strips machine-readable confirmation lines from stored user messages. */
export const formatUserMessageForDisplay = (text: string): string =>
    formatDebtBalancesUserMessageForDisplay(
        formatDraftedMessageUserMessageForDisplay(
            formatSliderUserMessageForDisplay(
                formatMultiSelectUserMessageForDisplay(text),
            ),
        ),
    );
